module.exports = __webpack_public_path__ + "img/pawprint.599d9771.svg";